// An account with nothing uploaded yet.

import { StateCard, Steps } from "../components/Controls.tsx";
import { Icon } from "../components/Icon.tsx";

export function Empty({ retry }: { retry: () => void }) {
  return (
    <StateCard icon="cloudUp" title="No trips online yet" id="empty-title">
      <p>Trips appear here after Carveny on your iPhone backs them up. The first backup can take a few minutes.</p>
      <Steps label="Start your first backup" steps={[
        <>Open <b>Carveny</b> on your iPhone.</>,
        <>In <b>Trips › Trip Settings › Carveny Online</b>, check backup is on and signed in with this Apple ID.</>,
        <>Tap <b>Back Up Now</b> to start straight away.</>,
      ]} />
      <div style={{ marginTop: 22, display: "flex", justifyContent: "center" }}>
        <button className="cv-btn cv-btn-secondary" type="button" onClick={retry}><Icon name="refresh" />Check Again</button>
      </div>
    </StateCard>
  );
}
